import React from 'react';
import { SocketProvider } from './src/lib/socket-provider';

export const wrapRootElement = ({ element }: { element: React.ReactNode }) => (
  <SocketProvider>{element}</SocketProvider>
);
